import { render, staticRenderFns } from "./profile-settings.vue?vue&type=template&id=5b087340&scoped=true"
import script from "./profile-settings.vue?vue&type=script&lang=ts"
export * from "./profile-settings.vue?vue&type=script&lang=ts"
import style0 from "./profile-settings.vue?vue&type=style&index=0&id=5b087340&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b087340",
  null
  
)

export default component.exports